import { api } from "@/api/axios";

import type {
  AuthUser,
  ForgotPasswordRequest,
  ForgotPasswordResponse,
  LoginRequest,
  LoginResponse,
  ResetPasswordRequest,
  ResetPasswordResponse,
} from "../types/auth";

export async function loginUser(
  data: LoginRequest,
): Promise<LoginResponse> {
  const response = await api.post<LoginResponse>(
    "/api/auth/login",
    data,
  );

  return response.data;
}

export async function getCurrentUser(): Promise<AuthUser> {
  const response = await api.get<AuthUser>(
    "/api/auth/me",
  );

  return response.data;
}

export async function forgotPassword(
  data: ForgotPasswordRequest,
): Promise<ForgotPasswordResponse> {
  const response =
    await api.post<ForgotPasswordResponse>(
      "/api/auth/forgot-password",
      data,
    );

  return response.data;
}

export async function resetPassword(
  data: ResetPasswordRequest,
): Promise<ResetPasswordResponse> {
  const response =
    await api.post<ResetPasswordResponse>(
      "/api/auth/reset-password",
      data,
    );

  return response.data;
}